export default __webpack_public_path__ + "static/media/navigation-arrow1.550e1802.webp";